module.exports = __webpack_public_path__ + "img/U1F4DE.cc7ceb07.png";